import { ReactElement } from "react";
import GoogleIcon from "@assets/icons/google.svg?react";
import AppleIcon from "@assets/icons/apple.svg?react";
import ProcoreIcon from "@assets/icons/procore.svg?react";
import AutodeskIcon from "@assets/icons/autodesk.svg?react";
import FaroIcon from "@assets/icons/faro.svg?react";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Additional information of each OAuth provider */
export const PROVIDER_INFO: Record<
  FaroCoreApiTypes.OAuthProvider,
  { icon: ReactElement; providerName: string } | undefined
> = {
  google: {
    icon: <GoogleIcon />,
    providerName: "Google",
  },
  apple: {
    icon: <AppleIcon />,
    providerName: "Apple",
  },
  procore: {
    icon: <ProcoreIcon />,
    providerName: "Procore",
  },
  autodesk: {
    icon: <AutodeskIcon />,
    providerName: "Autodesk",
  },
  ["faro-sphere"]: {
    icon: <FaroIcon />,
    providerName: "FARO",
  },

  // These providers are no longer supported
  facebook: undefined,
  plangrid: undefined,
  azuread: undefined,
};
